import _ from 'lodash';

export default class WMICVehicleService {
    static driverAlreadyAdded = (driver, driversAlreadyAdded) =>
        _.find(driversAlreadyAdded, driverAlreadyAdded => driverAlreadyAdded.driverPublicID_WMIC === driver.publicID);
}
